import { openContextModal } from "@mantine/modals";
import React from "react";

export const openInfoModal = (message: React.ReactNode) =>
	openContextModal({
		modal: "info",
		innerProps: {
			modalBody: message
		},
		withCloseButton: false
	});
